import Grid from '@material-ui/core/Grid';
import AssetRarityButtonGroup from "./assetRarityButtonGroup/AssetRarityButtonGroup";
import List from '@material-ui/core/List';
import { CircularProgress, Typography } from "@material-ui/core";
import { modalContentColor, modalMainContentColor } from "../lib/Color";
import { ExtensionDataType, DirectionType, FilterRarityType, StateType } from "./hooks/AssetSettingModalType";
import { PositionType } from "../Type/TeamType";
import { useState, useEffect } from 'react';
import { AssetToolTip } from './AssetToolTip';

type Props = {
    isAuto: boolean;
    state: StateType;
    extensions: ExtensionDataType[],
    setExtensionMode: (extensionMode: "ExtensionLeft" | "ExtensionRight") => void,
    selectedPosition: PositionType;
    filterExtensionData: (extensions: ExtensionDataType[], rarity: FilterRarityType) => ExtensionDataType[];
    updateTeamMemberExtensionData: (direction: DirectionType, extension: ExtensionDataType) => void
    onSelectStatePosition: (position: PositionType) => void,
    onSelectStateFilterRarity: (rarity: FilterRarityType) => void,
    nextStateMode: () => void
}

const ExtensionSettingContent = ({
    isAuto,
    state,
    extensions,
    setExtensionMode,
    selectedPosition,
    filterExtensionData,
    updateTeamMemberExtensionData,
    onSelectStatePosition,
    onSelectStateFilterRarity,
    nextStateMode
}: Props) => {
    const [extensionData, setExtensionData] = useState<ExtensionDataType[]>([]);

    useEffect(() => {
        setExtensionData(filterExtensionData(extensions, state.filterRarity))
    }, [extensions, state.filterRarity])

    const nextTeamPosition = (): PositionType => {
        switch (selectedPosition) {
            case "FRONT":
                return "MIDDLE";
            case "MIDDLE":
                return "BACK";
            case "BACK":
                return "BACK"
        }
    }

    const updateMemberLeftExtension = (extension: ExtensionDataType) => {
        updateTeamMemberExtensionData("Left", extension)
        if (isAuto) {
            setExtensionMode("ExtensionRight")
        }
    }

    const updateMemberRightExtension = (extension: ExtensionDataType) => {
        updateTeamMemberExtensionData("Right", extension)

        // TODO リファクタリング
        if (isAuto) {
            if (selectedPosition === "BACK") {
                nextStateMode()
            } else {
                setExtensionMode("ExtensionLeft")
                onSelectStatePosition(nextTeamPosition())
            }
        }
    }
    const updateMember = (extension: ExtensionDataType) => {
        const direction: DirectionType = state.mode === "ExtensionLeft" ? "Left" : "Right"
        switch (direction) {
            case "Left":
                return updateMemberLeftExtension(extension)
            case "Right":
                return updateMemberRightExtension(extension)
        }
    }
    console.log(extensionData)
    return (
        <>
            <Grid container style={{ backgroundColor: modalContentColor, height: '80vh' }} alignItems="center" justify="center">
                <Grid item >
                    <AssetRarityButtonGroup selectedRarity={state.filterRarity} onSelectStateFilterRarity={onSelectStateFilterRarity} />
                </Grid>
                <Grid item style={{ height: '90%', width: "100%", margin: "10px", overflow: "auto", backgroundColor: modalMainContentColor, borderColor: "white" }}>
                    <List>
                        {extensionData.length ? extensionData.map((extension) => {
                            return <AssetToolTip
                                title={
                                    <>
                                        <Typography color="inherit">{extension.name}</Typography>
                                        <Typography color="inherit">{extension.skill}</Typography>
                                        <Typography color="inherit">{extension.effect}</Typography>
                                        <Typography color="inherit">HP: {extension.hp} PHY: {extension.phy} INT: {extension.int} AGI: {extension.agi}</Typography>
                                    </>
                                }
                            >
                                <img
                                    src={"/images/extensions/" + extension.id + ".png"}
                                    style={{ width: 64, height: 64 }}
                                    onClick={() => updateMember(extension)}
                                />
                            </AssetToolTip>
                        }) : <CircularProgress disableShrink />}
                    </List>
                </Grid>
            </Grid>
        </>
    )
}

export default ExtensionSettingContent;